export default "__VITE_ASSET__D5hVsJP6__"